import hasRevokePermission from './hasRevokePermission';
import OmeMessageState, { OmeMessageResponseStatus } from '../store/schema/OmeMessageState';

export default function shouldAppendRevocationInfobar(omeMessageState: OmeMessageState): boolean {
    return (
        hasRevokePermission(omeMessageState) &&
        omeMessageState.responseState === OmeMessageResponseStatus.None
    );
}
